import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportationComponent } from './transportation.component';

import { DateSelectModule } from '../../components/date-select/date-select.module';
import { SvgIconModule } from '../../components/svg-icon';

@Pipe({ name: 'parseStopName' })
export class ParseStopName implements PipeTransform {
    transform(value: string): string {
        return value.replace(/\([^)]*\)/g, '');
    }
}

@Pipe({ name: 'replaceLineBreaks' })
export class ReplaceLineBreaks implements PipeTransform {
    transform(value: string): string {
        return value.replace(/;/g, ' ');
    }
}

@Pipe({ name: 'parseDirectionInfo' })
export class ParseDirectionInfo implements PipeTransform {
    transform(value: string): string {
        let duration = value.split(";").find(str => str.startsWith("Varighed:"));
        return duration ? "(" + duration.replace("Varighed: ", "") + ")" : "";
    }
}

@Pipe({ name: 'parseTowardsInfo' })
export class ParseTowardsInfo implements PipeTransform {
    transform(value: string): string {
        let towards = value.split(";").find(str => str.startsWith("Retning:"));
        return towards ? "<br>Towards " + towards.replace("Retning: ", "") + "" : "";
    }
}

/**
 * Convert journey string to a date number
 */
@Pipe({ name: 'journeyDate' })
export class JourneyDatePipe implements PipeTransform {
    transform(journeyData: string): number {
        if(!journeyData) return 0;
        console.log("Parsed date ", journeyData, TransportationComponent.parseTimestamp(journeyData, '0:0'))
        return TransportationComponent.parseTimestamp(journeyData, '0:0').getTime();
    }
}

@NgModule({
    declarations: [TransportationComponent, ReplaceLineBreaks, ParseDirectionInfo, ParseTowardsInfo, ParseStopName, JourneyDatePipe],
    imports: [
        CommonModule,
        SvgIconModule,
        DateSelectModule
    ],
    exports: [TransportationComponent, ReplaceLineBreaks, ParseDirectionInfo, ParseTowardsInfo, ParseStopName, JourneyDatePipe]
})
export class TransportationModule { }
